export default __webpack_public_path__ + "static/media/google.fa8bc675.svg";